import React, { Component } from "react";
import {DropzoneArea} from 'material-ui-dropzone'
import CancelIcon from '@material-ui/icons/Cancel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import api from '../api';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Link from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';
import Button from "@material-ui/core/Button";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Attachements extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {attachments:[], files:[], saving: false,severity:'sucess'}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.id
    	await this.getAttachments(work_order_id)
    }

    getAttachments(id){
		const token =localStorage.getItem('userToken')
		return axios
	     .get(api.work_order().attachments(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({attachments: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })

    }

  	handleCloseSuccess = () =>{
  		this.setState({openSuccess: false, success_message:'', files:[]})
  		this.getAttachments(this.props.id)
  	}

    handleChange = (files) => {
		this.setState({
			files: files
		});

    }

    handleSubmit = (e) => {
		this.setState({saving: true})
	    var formData = new FormData();
	    formData.set("work_order[id]", this.props.id);

	    this.state.files.map((val, idx) => {
	      formData.set(`media[${idx}]`, val)
	    })
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(api.work_order().attach_media(this.props.id),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		this.setState({openSuccess: true,success_message: 'Adjunto cargado con éxito',severity:'success'})
				this.setState({saving: false})
				this.setState({files:[]})
					  
	      })
	      .catch(function (error) {
			self.setState({saving: false})
			self.setState({files:[]})
	    	console.log(error)
			self.setState({openSuccess: true,success_message: 'Falló la carga del adjunto. Por favor reintentar',severity:'warning'})
	    })

    }

	handleDeleteMedia = (id) => {
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.delete(api.media().delete(id),{ headers: {"Authorization" : `Bearer ${token}`}},
	     {params: {'media[id]':id }}
	      )

	      .then((response)=> {
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'Adjunto eliminado con éxito', 
		  			severity:'warning'})
		  		this.getAttachments(this.props.work_order_id)
	      })

	      .catch(function (error) {
		  		self.setState({
		  			openSuccess: true,
		  			success_message: 'No pudo borrarse el adjunto. Por favor contacte a su administrador', 
		  			severity:'warning'})
	    })
	}


	render() {
		var attachments = this.state.attachments
		return (
			<React.Fragment>
				<Snackbar open={this.state.openSuccess} autoHideDuration={10000} onClose={this.handleCloseSuccess}>
					<Alert onClose={this.handleCloseSuccess} severity={this.state.severity}>
					  {this.state.success_message}
					</Alert>
				</Snackbar>
				<div className="row mb-2 mt-2">
					<div className="col-4 mt-2">
						<DropzoneArea onChange={(e)=>this.handleChange(e)} 
							dropzoneText="Arrastra los archivos aquí o buscalos"
							showPreviews="true"
							showPreviewsInDropzone={false}
							showFileNamesInPreview={false}
							showFileNames="true"
							className=""
						/>
					</div>
					<div className="col-8">
					    <Table aria-label="simple table">
					        <TableHead>
					          <TableRow>
					            <TableCell>Nombre del archivo</TableCell>
					            <TableCell></TableCell>
					          </TableRow>
					        </TableHead>
					        <TableBody>
					          {attachments.map((val,idx) => (
					            <TableRow key={val.id}>
					              <TableCell className="p-0" style={{fontSize: '0.7rem'}}>{val.name}</TableCell>
					              <TableCell className="p-0">
					              	<Link href={api.media_download+'/'+val.id} style={{fontSize: '0.7rem'}}><ArrowDownwardIcon />Descargar</Link>
									<Button onClick={(e)=>{this.handleDeleteMedia(val.id)}} style={{fontSize: '0.7rem', textTransform: 'none'}}><CancelIcon style={{height: '0.8rem', width: '0.8rem'}} /> Eliminar adjunto</Button>								              	 		

					              </TableCell>
					            </TableRow>
					          ))}
					        </TableBody>
					      </Table>
						  {(!(this.state.saving) && this.state.files.length >= 1)
						  ?
								<div className="row ml-1">
									<Button className="mt-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleSubmit}>Adjuntar</Button>
								</div>
						  :
							''
						  }

					</div>
				</div>

		      </React.Fragment>
		)
	}

}

export default Attachements;

